import { Home, HomeOutlined } from "@mui/icons-material"
import { MenuItem, Typography } from "@mui/material";
import {Link} from "react-router-dom";
import "./adminLeftbar.css"
import { useState } from "react";

export default function AdminLeftbar() {
    const [selected, setSelected] = useState("Dashboard");
    const Item =  ({ title, to, icon, selected, setSelected }) => {
        return (
            <MenuItem
                active={selected === title}
                onClick={() => setSelected(title)}
                icon={icon}>
                <Typography>{title}</Typography>
                <Link to={to} />
            </MenuItem>
        )
    };

  return (
    <div className="adminleftbar">
      <div className="adminleftbarWrapper">
        <div className="adminleftbarTop">
            <Item
                title="Dashboard"
                to="/admin"
                icon={<Home />}
                selected={selected}
                setSelected={setSelected}
            />
        </div>
      </div>
    </div>
  )
}